export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[700px] mx-auto bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-10 text-center">
          <div className="w-14 h-14 rounded-2xl bg-primary-100/80 flex items-center justify-center mx-auto mb-5">
            <i className="ri-mail-send-line text-primary-500 text-2xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">联系我们</h2>
          <p className="text-foreground-600 text-sm leading-relaxed mb-6 max-w-md mx-auto">
            有任何建议、合作意向或版权问题，欢迎随时联系我们。飞飞漫画网始终以读者体验为核心，你的反馈是我们持续优化的动力。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <div className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center">
                <i className="ri-mail-line text-primary-500"></i>
              </div>
              <span>contact@feifeicomics.com</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <div className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center">
                <i className="ri-wechat-line text-primary-500"></i>
              </div>
              <span>飞飞漫画官方公众号</span>
            </div>
          </div>

          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              const el = document.querySelector('#hero');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap no-underline"
          >
            <i className="ri-arrow-up-line"></i>
            返回顶部
          </a>
        </div>
      </div>
    </section>
  );
}